export default __webpack_public_path__ + "static/media/q28_step2.b481aa4c.png";